import React from 'react'
import Breadcrumbs from './../../../CommonElements/Breadcrumbs/index';
import ReviewsTable from './ReviewsTable';

function Reviews() {
    return (
        <>
            <Breadcrumbs mainTitle="Reviews Management" parent="Review" title="Reviews" />
            <ReviewsTable />
        </>
    )
}

export default Reviews
